import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { changeName, updateBusiness, } from "../store/businessSlice";


const BusinessRenameModal = ({ show, setRenameModal, tenantId }) => {
  const dispatch = useDispatch();

  const { name } = useSelector((state) => state?.business);

  const handleSubmit = () => {
    const data = {
      business_name: name,
    };
    dispatch(updateBusiness({ data, id: tenantId }));
  };
  return (
    <>
      <Modal
        show={show}
        keyboard={true}
        size="md"
        onHide={() => {
          setRenameModal(false);
        }}
        dialogClassName="modal-dialog modal-dialog-centered"
      >
        <Modal.Header closeButton>
          <Modal.Title>Business Rename</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ borderBottom: '1px solid lightgray' }}>
          <Row>
            <Col lg={12}>
              <Form.Group>
                <Form.Label style={{ fontSize: "13px", fontWeight: 400 }}>
                  New Business Name
                </Form.Label>
                <span className="required" />
                <Form.Control
                  placeholder="Enter your new business name"
                  name="name"
                  value={name}
                  onChange={(e) => {
                    dispatch(changeName(e.target.value));
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer >
          <Row className="py-1" >
            <Col lg={5} md={5} sm={5} xs={5}>
              <Button onClick={handleSubmit} className="">
                Save
              </Button>
            </Col>
            <Col lg={5} md={5} sm={5} xs={5}>
              <Button
                variant="outline-secondary "
                className=""
                onClick={() => {
                  dispatch(changeName(""))
                  setRenameModal(false)
                }
                }
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BusinessRenameModal;
